// B1223, corrected by B1229: where the console links to the embedded-engine
// demonstrations. `demos/index.html` is a vite input (web/vite.config.js), so
// `bun run build` writes dist/demos/index.html, and a node serves /ui/<rel> from its
// webroot (web/dist). The link names the DIRECTORY: since B1229 a node serves the
// index.html of a webroot directory, so /ui/demos/ answers with dist/demos/index.html
// and /ui/demos answers 302 to /ui/demos/. web/scripts/demos-console.test.js keeps this
// and the vite input in step.
export const DEMOS_HREF = '/ui/demos/';
